function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M127.415,38.452a6.509,6.509,0,0,0-4.577,11.041,5.325,5.325,0,0,1,1.537,3.716v3.419a3.134,3.134,0,1,0,6.268,0V53.209a5.242,5.242,0,0,1,1.513-3.691,6.509,6.509,0,0,0-4.74-11.066Zm-1.594,15.524H129.2v1.473h-3.375Zm1.687,4.339a1.69,1.69,0,0,1-1.666-1.42h3.332A1.69,1.69,0,0,1,127.509,58.316Zm3.614-9.81a6.68,6.68,0,0,0-1.892,4.025h-3.444a6.8,6.8,0,0,0-1.911-4.044,5.033,5.033,0,0,1-1.429-3.57,5.09,5.09,0,0,1,4.989-5.017h.074a5.062,5.062,0,0,1,3.614,8.607Z",
  transform: "translate(-115.166 -38.119)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M0,157.4H3.664v1.446H0Z",
  transform: "translate(0 -151.329)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M0,0H3.664V1.446H0Z",
  transform: "matrix(0.866, -0.5, 0.5, 0.866, 1.266, 12.342)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M0,0H1.446V3.664H0Z",
  transform: "matrix(0.5, -0.866, 0.866, 0.5, 19.471, 11.851)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M436,159.506h3.664v1.446H436Z",
  transform: "translate(-414.975 -153.337)",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M0,0H3.664V1.446H0Z",
  transform: "matrix(0.866, -0.5, 0.5, 0.866, 19.522, 1.92)",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M0,0H1.446V3.664H0Z",
  transform: "matrix(0.5, -0.866, 0.866, 0.5, 1.317, 1.253)",
  fill: "#fff"
});

var SvgHint = function SvgHint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "light-bulb",
    width: 24.685,
    height: 21.643,
    viewBox: "0 0 24.685 21.643",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hint.1736210f.svg";
export { ForwardRef as ReactComponent };